module.exports = __webpack_public_path__ + "img/she-came-to-slay-the-life-and-times-of-harriet-tubman.20aa9dad.png";